import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 34.36 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M.17 10.11h8.56l3.59 8.22c-5.47 2.42-9.25 7.94-9.15 14.28a15.26 15.26 0 0 0 4.66 10.81c2.89 2.81 6.68 4.35 10.71 4.35h.23c4.1-.06 7.94-1.71 10.8-4.66 2.87-2.94 4.41-6.83 4.35-10.94-.12-8.4-6.99-15.16-15.37-15.16h-.23a15.5 15.5 0 0 0-3.63.49L8.19 2.66l5.71-.23c.23.03 1.23.21 1.72.92.39.57.41 1.44.07 2.58a1.25 1.25 0 0 0 2.39.73c.58-1.9.44-3.49-.4-4.72-1.22-1.78-3.4-1.99-3.64-2.01h-.14l-7.64.3a1.255 1.255 0 0 0-1.1 1.75l2.46 5.63H.17v2.5Zm27.61 31.26c-2.4 2.47-5.61 3.85-9.05 3.9-3.47.06-6.69-1.24-9.16-3.64-2.47-2.4-3.85-5.61-3.9-9.05-.08-5.31 3.08-9.92 7.65-11.96l5.18 11.83c.21.47.67.75 1.15.75.17 0 .34-.04.5-.11.63-.27.92-1.01.64-1.64l-5.08-11.62c.85-.2 1.74-.31 2.65-.32h.19c7.01 0 12.77 5.66 12.87 12.7.05 3.44-1.24 6.69-3.64 9.16Z" />
    </svg>
  )
}
export default Icon
